export default __webpack_public_path__ + "static/media/trusted-by-met.3faf9fde.png";